import _ from 'lodash';

import type { DrawerProps } from 'antd';
import type { ProDescriptionsActionType } from "@ant-design/pro-descriptions";
import type {ProFormProps} from '@ant-design/pro-form';

import React, { useRef } from 'react';
import {Button, Drawer, Space, Row, Col, Form, } from 'antd';
import {FooterToolbar} from '@ant-design/pro-layout';
import ProForm, {ModalForm, DrawerForm, ProFormText, ProFormSwitch, } from '@ant-design/pro-form';

import FormLayout from './../../../../utils/ui/layout/FormLayout';

import { LedMachinePlatform } from './../../type/LedMachinePlatformType';
import LedMachinePlatformApi from '../../api/LedMachinePlatformApi';
import { message } from 'antd';

export interface LedMachinePlatformAddFormProps extends DrawerProps {
    onFail:()=>void,
    onSuccess:()=>void,
};



const LedMachinePlatformAddForm:React.FC<LedMachinePlatformAddFormProps> = (props)=>{

    const [form] = Form.useForm<LedMachinePlatform>();
    const {onFail, onSuccess} = props;

    return (
        <Drawer
            title="新建LED屏幕云平台"
            destroyOnClose={false}
            closable={false}
            width={960}
            extra={[
                <Button
                    key='closeBtn'
                    type='primary'
                    style={{backgroundColor:'red', border:0}}
                    onClick={onFail}
                >
                    关闭
                </Button>
            ]}
            {..._.omit(props, 'onFail', 'onSuccess')}
        >
            <ProForm
                submitter={{
                    render: (_, dom) => <div style={{textAlign:'right', marginTop:16}}><Space>{dom}</Space></div>,
                }}
                onFinish={async (values:  LedMachinePlatform)=>{
                    await LedMachinePlatformApi.addLedMachinePlatform(values);
                    form.resetFields();
                    message.success("新建LED屏幕云平台成功！");
                    if(onSuccess){
                        onSuccess();
                    }else{
                        onFail();
                    }
                    return true;
                }}
                form={form}
                layout={'horizontal'}
            >
                <Row>
                    <Col span={12}>
                        <ProFormText
                            name={['code']}
                            label="平台编码"
                            tooltip=""
                            placeholder=""
                            rules={[{required:true, message: "平台编码不能为空"}]}
                            {...FormLayout.itemLayout.span12}
                        />
                    </Col>
                    <Col span={12}>
                        <ProFormText
                            name={['name']}
                            label="平台名称"
                            tooltip=""
                            placeholder=""
                            rules={[{required:true, message: "平台名称不能为空"}]}
                            {...FormLayout.itemLayout.span12}
                        />
                    </Col>
                    <Col span={24}>
                        <ProFormText
                            name={['url']}
                            label="平台地址"
                            tooltip=""
                            placeholder=""
                            rules={[{required:true, message: "平台地址不能为空"}]}
                            {...FormLayout.itemLayout.span24}
                        />
                    </Col>
                    <Col span={24}>
                        <ProFormText
                            name={['apiUrl']}
                            label="接口地址"
                            tooltip=""
                            placeholder=""
                            rules={[{required:true, message: "接口地址不能为空"}]}
                            {...FormLayout.itemLayout.span24}
                        />
                    </Col>
                    <Col span={12}>
                        <ProFormSwitch
                            name={['enabledFlag']}
                            label="启用"
                            tooltip=""
                            placeholder=""
                            rules={[{required:true, message: "启用不能为空"}]}
                            {...FormLayout.itemLayout.span12}
                        />
                    </Col>
                    <Col span={12}>
                        <ProFormText
                            name={['appPlatformCode']}
                            label="应用平台编号"
                            tooltip=""
                            placeholder=""
                            rules={[{required:false, message: "应用平台编号不能为空"}]}
                            {...FormLayout.itemLayout.span12}
                        />
                    </Col>
                    <Col span={24}>
                        <ProFormText
                            name={['appId']}
                            label="APP ID"
                            tooltip=""
                            placeholder=""
                            rules={[{required:false, message: "APP ID不能为空"}]}
                            {...FormLayout.itemLayout.span24}
                        />
                    </Col>
                    <Col span={24}>
                        <ProFormText
                            name={['appKey']}
                            label="APP KEY"
                            tooltip=""
                            placeholder=""
                            rules={[{required:false, message: "APP KEY不能为空"}]}
                            {...FormLayout.itemLayout.span24}
                        />
                    </Col>
                    <Col span={24}>
                        <ProFormText
                            name={['appSecret']}
                            label="APP Secret"
                            tooltip=""
                            placeholder=""
                            rules={[{required:false, message: "APP Secret不能为空"}]}
                            {...FormLayout.itemLayout.span24}
                        />
                    </Col>
                </Row>
            </ProForm>
        </Drawer>
    );
};

export default LedMachinePlatformAddForm;